import React, { useContext, useEffect, useState } from "react";
import Switch from "react-switch";
import { ModalContext } from "../../context/ModalContext";
import { PackagesContext } from "../../context/PackageContext";
import { PaymentMethodsContext } from "../../context/PaymentMethodsContext";

const AddPurchaseForm = ({ customer, extenderAcceso }) => {
  const [dias, setDias] = useState(0);
  const [gift, setGift] = useState(false);
  const [total, setTotal] = useState("");
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [paquete, setPaquete] = useState(null);
  const [packageID, setpackageID] = useState(null);
  const { clearModal } = useContext(ModalContext);

  const { paquetes, getPaquetes } = useContext(PackagesContext);
  const { payment_methods: paymentMethods, getPaymentMethods } = useContext(
    PaymentMethodsContext
  );

  useEffect(() => {
    getPaymentMethods();
    getPaquetes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (paquetes && paquetes !== null && paquete === null) {
      const current = paquetes[0];
      setPaquete(current);
      setpackageID(current.class_package_id);
      setDias(current.expiration_days);
      setTotal(current.price);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paquetes]);

  useEffect(() => {
    if (paquete !== null) {
      setPaymentMethod(2);
    }
  }, [paquete]);

  useEffect(() => {
    if (Array.isArray(paquetes)) {
      const current = paquetes?.find(
        (paquete) => paquete.class_package_id === parseInt(packageID)
      );
      if (current) {
        setPaquete(current);
        setDias(current.expiration_days);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paquetes, packageID]);

  const renderPaquetes = () => {
    if (paquetes && paquetes !== null) {
      return paquetes.map((paquete) => (
        <option key={paquete.class_package_id} value={paquete.class_package_id}>
          {paquete.title}
        </option>
      ));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    extenderAcceso({
      customer_id: customer.customer_id,
      class_package_id: packageID,
      expiration_days: dias,
      is_gift: gift,
      total,
      payment_method_id: paymentMethod,
    });
  };

  const renderPaymentMethods = () => {
    if (Array.isArray(paymentMethods)) {
      return paymentMethods.map((payment_method) => (
        <option
          key={payment_method.payment_method_id}
          value={payment_method.payment_method_id}
        >
          {payment_method.name}
        </option>
      ));
    }
  };

  return (
    <div className="container-fluid px-0">
      <form onSubmit={handleSubmit}>
        <label>Paquete</label>
        <select
          className="form-control mb-3"
          onChange={(e) => setpackageID(e.target.value)}
        >
          {renderPaquetes()}
        </select>
        <label className="">Número de Días</label>
        <input
          type="number"
          className="form-control mb-3"
          value={dias}
          onChange={(e) => setDias(e.target.value)}
        />
        <label>Total Pagado</label>
        <input
          type="number"
          className="form-control mb-3"
          value={total}
          onChange={(e) => setTotal(e.target.value)}
        />
        <label className="d-block">¿Es Regalo?</label>
        <Switch
          checked={gift}
          className="d-block mt-1 mb-3"
          onChange={(checked) => setGift(checked)}
        />
        {!gift && (
          <>
            <label className="d-block">Método de Pago</label>
            <select
              className="form-control mb-3"
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
            >
              {renderPaymentMethods()}
            </select>
          </>
        )}

        <div className="row mt-3">
          <div className="col-6">
            <button
              type="button"
              className="btn btn-link text-secondary w-100"
              onClick={clearModal}
            >
              Cancelar
            </button>
          </div>
          <div className="col-6">
            <button type="submit" className="btn btn-primary w-100">
              Extender Acceso
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddPurchaseForm;
